import { AnalyticsTabItem, InspectionViewState, MsAnalyticsTabType } from 'store/analytics/ui/analyticsUiTypes';
import { HttpRequest, InspectionViewRequest, TxiViewRequest } from 'types/rest/analyticsTypes';
import { RunnerTypes } from '../../../components/ui/ButtonGroups/RunnersButtonGroup';

/* Analytics Action types */
export const ADD_ANALYTICS_TAB = 'ADD_ANALYTICS_TAB';
export const UPDATE_ANALYTICS_TAB_META = 'UPDATE_ANALYTICS_TAB_META';
export const SELECT_ANALYTICS_TAB = 'SELECT_ANALYTICS_TAB';
export const CLOSE_ANALYTICS_TAB = 'CLOSE_ANALYTICS_TAB';
export const CLEAR_ANALYTICS_TABS = 'CLEAR_ANALYTICS_TABS';
export const SET_IS_MOCK_SERVICES_LOADING = 'SET_IS_MOCK_SERVICES_LOADING';
export const SET_IS_MOCK_SERVICE_DATA_INITIALISED = 'SET_IS_MOCK_SERVICE_DATA_INITIALISED';
export const CHANGE_MS_ANALYTICS_CONTENT_TAB = 'CHANGE_MS_ANALYTICS_CONTENT_TAB';
export const SET_ACTIVE_RUNNER_TAB = 'SET_ACTIVE_RUNNER_TAB';
export const SET_INSPECTION_VIEW = 'SET_INSPECTION_VIEW';
export const SELECT_INSPECTION_VIEW_REQUEST_FOR_TAB = 'SELECT_INSPECTION_VIEW_REQUEST_FOR_TAB';

export type AddAnalyticsTab = {
  type: typeof ADD_ANALYTICS_TAB;
  payload: AnalyticsTabItem;
};

export type UpdateAnalyticsTabMeta = {
  type: typeof UPDATE_ANALYTICS_TAB_META;
  payload: {
    id: string | number;
    meta: any;
  };
};

export type ClearAnalyticsTabs = {
  type: typeof CLEAR_ANALYTICS_TABS;
};

export type CloseAnalyticsTab = {
  type: typeof CLOSE_ANALYTICS_TAB;
  payload: number | string; //Id to be closed
};

export type SelectAnalyticsTab = {
  type: typeof SELECT_ANALYTICS_TAB;
  payload: number | string; //Id to be focused
};

export type SetIsMockServicesLoading = {
  type: typeof SET_IS_MOCK_SERVICES_LOADING;
  payload: boolean;
};

export type SetIsMockServicesMetadataInitialised = {
  type: typeof SET_IS_MOCK_SERVICE_DATA_INITIALISED;
  payload: boolean;
};

export type ChangeMsContentTab = {
  type: typeof CHANGE_MS_ANALYTICS_CONTENT_TAB;
  payload: MsAnalyticsTabType;
};

export type SetActiveRunnerTab = {
  type: typeof SET_ACTIVE_RUNNER_TAB;
  payload: RunnerTypes;
};

export type SetInspectionView = {
  type: typeof SET_INSPECTION_VIEW;
  payload: InspectionViewState;
};

export type SelectInspectionViewRequestForTab = {
  type: typeof SELECT_INSPECTION_VIEW_REQUEST_FOR_TAB;
  payload: {
    tabId: number | null;
    request: InspectionViewRequest | TxiViewRequest | null;
  };
};

export const SELECT_WEBHOOK_VIEW_REQUEST_FOR_TAB = 'SELECT_WEBHOOK_VIEW_REQUEST_FOR_TAB';
export type SelectWebhookViewRequestForTab = {
  type: typeof SELECT_WEBHOOK_VIEW_REQUEST_FOR_TAB;
  payload: {
    tabId: number | null;
    webhook: HttpRequest | null;
  };
};

export type AnalyticsUiActionTypes =
  | AddAnalyticsTab
  | ClearAnalyticsTabs
  | SetIsMockServicesLoading
  | SetIsMockServicesMetadataInitialised
  | SetActiveRunnerTab
  | SetInspectionView
  | CloseAnalyticsTab
  | SelectAnalyticsTab
  | ChangeMsContentTab
  | UpdateAnalyticsTabMeta
  | SelectInspectionViewRequestForTab
  | SelectWebhookViewRequestForTab;
